// eslint-disable-next-line no-unused-vars
import React from 'react';
import { string } from 'prop-types';
import {
  TableRow,
  TableCell,
  SkeletonPlaceholder,
  SkeletonText
} from '@carbon/react';
import styled from '@emotion/styled';

const StyledContainer = styled.div`
  display: grid;
  grid-template-columns: 10% 50% 25%;
  grid-column-gap: 25px;
  justify-content: space-between;
  margin: 15px 0;
`;

const ProductSkeletonItem = ({ type, className }) => type === 'table'
  ? (
    <TableRow className={ `skeleton ${ className || '' }` }>
      <TableCell><SkeletonPlaceholder /></TableCell>
      <TableCell><SkeletonText width="100%" /></TableCell>
      <TableCell><SkeletonText width="100%" /></TableCell>
      <TableCell><SkeletonText width="100%" /></TableCell>
      <TableCell><SkeletonText width="100%" /></TableCell>
      <TableCell><SkeletonText width="100%" /></TableCell>
      <TableCell colSpan={ 2 }><SkeletonText width="100%" /></TableCell>
    </TableRow>
  )
  : (
    <StyledContainer className={ `skeleton ${ className || '' }` }>
      <SkeletonPlaceholder />
      <SkeletonText paragraph />
      <SkeletonText lineCount={ 2 } />
    </StyledContainer>
  );

ProductSkeletonItem.propTypes = {
  type: string,
  className: string
};

export default ProductSkeletonItem;
